import { render } from "./PayAudioPlayerShell.vue?vue&type=template&id=73834bf4&scoped=true"
import script from "./PayAudioPlayerShell.vue?vue&type=script&lang=js"
export * from "./PayAudioPlayerShell.vue?vue&type=script&lang=js"

import "./PayAudioPlayerShell.vue?vue&type=style&index=0&id=73834bf4&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73834bf4"]])

export default __exports__